import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getWithdraw} from '../../../apis/withdraw/withdraw'

const useQueryWithdraw = (status?: string, before?: number) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.other.getWithdraw(),
        queryFn: async () => {
            const {data, pageInfo} = await getWithdraw(status, before)
            return {data, pageInfo}
        },
    })

    return {data, refetch}
}

export default useQueryWithdraw
